import { IBaseModel, ILocation } from './common';
import moment from 'moment';
import { IHotspotModel } from './HotspotsModel';
import { IEmployeeModel } from './EmployeesModel';
import { IVehicleCountModel } from '.';

export interface IOnRoadTasksModel {
  onRoadTasksList: IOnRoadTaskModel[];
  isLoading: boolean;
  onRoadTaskStatus: IOnRoadTaskStatusModel;
  isUpdatingTasks: boolean;
}

export interface IOnRoadTaskModel extends IBaseModel {
  completeVehicleStateId: number;
  employeeId: string;
  employee?: IEmployeeModel;
  location: ILocation | IHotspotModel;
  needsProof: boolean;
  ownerCompanyId: string;
  initialQuantity?: number;
  quantity: number;
  regionId: string;
  startedAt: moment.Moment;
  status: OnroadTaskStatus;
  type: OnroadTaskType;
  comment?: string;
}

export enum OnroadTaskType {
  PickUp = 'pickup',
  PickupNotFound = 'pickup-not-found',
  Drop = 'drop',
  SwapBattery = 'swap-battery',
  Relocate = 'relocate', // only for unassigned tasks
  DropToWarehouse = 'drop-to-warehouse',
}

export enum OnroadTaskStatus {
  NotStarted = 'not-started',
  InProgress = 'in-progress',
  Completed = 'completed',
  Cancelled = 'cancelled',
  PartiallyCancelled = 'partially-cancelled',
  NeedsProof = 'needs-proof',
  UnderAssignment = 'under-assignment',
}

export interface IOnRoadTaskStatusModel {
  [key: string]: IVehicleCountModel[];
}
